import React, { useEffect, useState } from 'react';
import './DashboardSignatureTable.css';
import { useNavigate } from 'react-router-dom';
import { api, endpoints } from '../config/api';
import { Alert, Spinner } from './ui';
import { useT } from '../i18n';

const messages = {
  error: { tr: 'Hata: {msg}', en: 'Error: {msg}' },
  title: { tr: 'İmzalar', en: 'Signatures' },
  colName: { tr: 'İSİM', en: 'NAME' },
  colGroups: { tr: 'ATANDIĞI GRUPLAR', en: 'ASSIGNED GROUPS' },
  colPriority: { tr: 'ÖNCELİK', en: 'PRIORITY' },
  colCreated: { tr: 'OLUŞTURMA TARİHİ', en: 'CREATED' },
};

export default function DashboardSignatureTable() {
  const [signatures, setSignatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { t, formatDate } = useT(messages);

  useEffect(() => {
    const loadSignatures = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await api.get(endpoints.signatures.templates.list);
        setSignatures(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadSignatures();
  }, []);

  if (loading) return <div className="page-loading"><Spinner /></div>;
  if (error) return <Alert variant="error">{t('error', { msg: error })}</Alert>;

  return (
    <div className="mini-table-card dashboard-signature-table" onClick={() => navigate('/signatures')}>
      <h2>{t('title')}</h2>
      <table className="data-table data-table-scroll">
        <thead>
          <tr>
            <th>{t('colName')}</th>
            <th>{t('colGroups')}</th>
            <th>{t('colPriority')}</th>
            <th>{t('colCreated')}</th>
          </tr>
        </thead>
        <tbody>
          {signatures.map(sig => (
            <tr key={sig.id}>
              <td>{sig.name}</td>
              <td>{Array.isArray(sig.assignments) ? sig.assignments.map(a => a.group_name).join(', ') : ''}</td>
              <td>{Array.isArray(sig.assignments) ? sig.assignments.map(a => `${a.group_name}: ${a.priority}`).join('; ') : ''}</td>
              <td>{formatDate(sig.created_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}